import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs';

import { HttpApiService } from '@core/http-legacy';
import type { LocationsTranslationCounter } from '@core/locations-types';
import type { Scope } from '@core/ngrx-legacy';

@Injectable({ providedIn: 'root' })
export class LocationsTranslationCountersHttpClient {
  protected readonly httpApi = inject(HttpApiService);

  public fetch(scope: Scope): Observable<LocationsTranslationCounter[]> {
    return this.httpApi
      .get(`/locations/translation_counters`, { scope })
      .pipe(map(response => response.translationsCounters));
  }
}
